import { handleError } from "./utils";

export const initialize = (store) => handleError(async (dispatch, getState, { api }) => {
    dispatch({ type: 'INITIALIZING', running: true });
    const user = await api.initialize(store);  
    dispatch({ type: 'INITIALIZING', running: false });
  }, 'An error has occurred initializing the system');